import React, { useState } from "react";
import styles from "../../Dashboard/Order/OrderModal/users.module.css";
import { RxCross1 } from "react-icons/rx";
import { useSelector } from "react-redux";
import ReferralInfo from "./ReferralModalTab/ReferralInfo";

const ReferralModal = ({
  handleCloseOrderModal,
  isOrderDetail,
  referralData,
}) => {
  const [toggleContent, setToggleContent] = useState("Details");

  const { theme } = useSelector((state) => state.theme);
  if (isOrderDetail) {
    return (
      <>
        <div className={styles.main}>
          <div
            className={`${styles.container} ${
              theme === "light"
                ? "bg-secondaryColor text-textColorLight"
                : "bg-darkThirsary text-darkSecondary"
            } `}
          >
            <div className={`${styles.header_div} `}>
              <div>
                <span style={{ fontSize: "1.4rem" }}>Referral Inforation</span>
                <div className="flex gap-1 px-3 py-2 rounded-md bg-gray-100   items-center justify-center w-fit">
                  <p className="w-fit rounded-md capitalize font-semibold text-[var(--color--2)]">
                    {referralData?.user_role?.name}
                  </p>
                </div>
              </div>

              <RxCross1
                size={"1rem"}
                onClick={() => handleCloseOrderModal()}
                cursor={"pointer"}
              />
            </div>

            {/* <hr /> */}
            {/* <div style={{ display: "flex", marginBottom: "1rem" }}>
              {["Details", "Applied", "Usage", "Chat"].map((item) => (
                <hr
                  style={{
                    width: "25%",
                    borderTop:
                      item === toggleContent ? "5px solid  " : "1px solid",
                    color:
                      item === toggleContent
                        ? "rgb(15 61 100 / var(--tw-text-opacity)"
                        : "var(--light-color3)",
                    borderRadius: "10px",
                    borderBottom: "none",
                    borderLeft: "none",
                    borderRight: "none",
                  }}
                />
              ))}
            </div> */}

            {/* <div className={`${styles.content_list}  border-black-700 `}>
              {[].map((item) => (
                <span
                  onClick={() => setToggleContent(item)}
                  style={{
                    color:
                      item === toggleContent
                        ? "var(--color--2) "
                        : "var(--light-color3)",
                    cursor: "pointer",
                  }}
                >
                  {item}
                </span>
              ))}
            </div> */}
            <hr />
            {toggleContent === "Details" && (
              <ReferralInfo
                referralData={referralData}
                // orderDetails={referralData}
              />
            )}
            {/* {toggleContent === "Applied" && (
              <PromocodFor promo={promocodeData} />
            )}
            {toggleContent === "Usage" && (
              <OrderStatus orderStatus={promocodeData?.orderStatus} />
            )}
            {toggleContent === "Chat" && <OrderChat />} */}
          </div>
        </div>
      </>
    );
  }
};

export default ReferralModal;
